module.exports = __webpack_public_path__ + "fonts/EBGaramond-Italic-VariableFont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/EBGaramond/EBGaramond-Italic-VariableFont.woff2
// module id = 3491
// module chunks = 0